import helpers from '@/helpers'
import filters from '@/filters'

export const colorShiftHelpers = {
  methods: {
    hexToRgba(hex, opacity) {
      var rgbArr = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
                 ,(m, r, g, b) => '#' + r + r + g + g + b + b)
        .substring(1).match(/.{2}/g)
        .map(x => parseInt(x, 16))
      var res = opacity ? `rgba(${rgbArr[0]}, ${rgbArr[1]}, ${rgbArr[2]}, ${opacity})` : `rgba(${rgbArr[0]}, ${rgbArr[1]}, ${rgbArr[2]})`
      return res
    },
    rgbToHex(rgb) {
      var nums = /(.*?)rgb\((\d+),\s*(\d+),\s*(\d+)\)/i.exec(rgb),
        r = parseInt(nums[2], 10).toString(16),
        g = parseInt(nums[3], 10).toString(16),
        b = parseInt(nums[4], 10).toString(16);
      const res = '#' + [r, g, b].map(x => {
        const hex = x.toString(16)
        return hex.length === 1 ? '0' + hex : hex
      }).join('')
      return res
    },
    addAlpha(color, alpha) {
      if (color) {
        if (color.includes('rgba') == false) {
          if (color.includes('rgb') == false) {
            return this.hexToRgba(color, alpha)
          } else {
            return color.replace('rbg', 'rgba').replace(')', `, ${alpha})`)
          }
        } else {
          return color.replace(/[\d.]+\)$/g, `${alpha})`)
        }
      }
    }
  }
}

export const arrayHelpers = {
  methods: {
    multiFilter(arr, filters) {
      const filterKeys = Object.keys(filters)
      let list = []
      filterKeys.forEach(key => {
        if (filters[key].length) {
          list.push(arr.filter(obj => {
            return filters[key].includes(obj[key])
          }))
        }
      })
      return list[0]
    },
    groupBy(xs, key) {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    mergeArray(source, merge, by) {
      return source.map(item => ({
        ...item,
        ...(merge.find(i => i[by] === item[by]) || {}),
      }));
    }
  }
}

export const calcHelpers = {
  methods: {
    average(arr) {
      return arr.reduce((p, c) => p + c, 0) / arr.length;
    },
    sum(arr) {
      return arr.reduce((p, c) => p + c, 0);
    }
  }
}

export const dateHelpers = {
  methods: {
    getDatesBetween(s,e) {
      for (var a=[], d=s; d<=e; d.setDate(d.getDate()+1)) {
        a.push(new Date(d));
      }
      return a;
    }
  }
}

export const drawingHighlightStatus = {
  computed: {
    highlightStatus(highlight) {
      if (highlight.is_approved) {
        return 'Approved'
      } else if (highlight.is_in_revision) {
        return 'Revision Requested'
      } else if (highlight.is_completed) {
        return 'Completed'
      } else {
        return 'Requested'
      }
    }
  }, 
  methods: {
    getHighlightStatus(highlight) {
      if (highlight.is_approved) {
        return 'Approved'
      } else if (highlight.is_in_revision) {
        return 'Revision Requested'
      } else if (highlight.is_completed) {
        return 'Completed'
      } else {
        return 'Requested'
      }
    }
  }
}

export const estimationStatus = {
  computed: {
    estimationStatus({ estimation }) {
      if (estimation.is_client_approved) {
        return 'Client Approved'
      } else if (estimation.is_completed) {
        return 'Completed'
      } else if (estimation.is_ready_for_pricing) {
        return 'Ready for Pricing'
      } else if (estimation.is_in_progress) {
        return 'In Progress'
      } else {
        return 'In Progress'
      }
    }
  },
  methods: {
    getEstimationStatus(estimation) {
      if (estimation.is_client_approved) {
        return 'Client Approved'
      } else if (estimation.is_completed) {
        return 'Completed'
      } else if (estimation.is_ready_for_pricing) {
        return 'Ready for Pricing'
      } else if (estimation.is_in_progress) {
        return 'In Progress'
      } else {
        return 'In Progress'
      }
    }
  }
}


export const rfqStatus = {
  computed: {
    status({ rfq }) {
      if (rfq.is_accepted) {
        return 'RFQ Accepted'
      } else if (rfq.needs_revision) {
        return 'Revision Needed'
      } else if (rfq.is_completed) {
        return 'Awaiting Estimator Review'
      } else {
        return 'In Progress'
      }
    }
  },
  methods: {
    getRfqStatus(rfq) {
      if (rfq.is_accepted) {
        return 'RFQ Accepted'
      } else if (rfq.needs_revision) {
        return 'Revision Needed'
      } else if (rfq.is_completed) {
        return 'Awaiting Estimator Review'
      } else {
        return 'In Progress'
      }
    }
  }
}


export const estimationHelpers = {
  data() {
    return {
      alph: [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
        'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
        'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
      ],
      elevations: [
        'North', 'South', 'West', 'East', 'N/ East', 
        'N/ West', 'S/ East', 'S/ West', 'Whole Building'
      ],
      modifiedDetails: []
    }
  },
  computed: {
    wallTotCols() {
      return this.wallFields.length
    },
    railTotCols() {
      return this.railFields.length
    }
  },
  methods: {
    checkMaterials() {
      this.getMaterials({ per_page: 100 }).then(
        () => this.initializeSpreadsheet()
      )
    },
    setWidth() {
      let el = document.querySelector('.estimation__details');
      this.detailWidth = el.clientWidth - parseFloat(helpers.getStyle(
        el, 'padding-left'
      ).replace("px", "")) - parseFloat(helpers.getStyle(
        el, 'padding-right'
      ).replace("px", "")) - 43.6;
    },
    updateParam(field, value) {
      this.estimation[field] = value;
    }, 
    getMinorCells(minor) {
      if (24 <= minor <= 43) {
        [39,33,27,24].forEach((threshold, i) => {
          if (minor>=threshold) {
            return (6-i)
          }      
        })
      } else {
        return 0
      }  
    },
    getMajorCells(major) {
      if (48 <= major <= 80) {
        [80,74,68,61,55,49,48].forEach((threshold, i) => {
          if (major >= threshold) {
            return 12-i
          }  
        })
      } else {
        return 0
      }
    },
    getCellQty(length, width, panels) {
      ```
      Minor rules:
      ------------
      #3: 24" to 26"
      #4: 27" to 32"
      #5: 33" to 38"
      #6: 39" to 43"
      Major rules:
      ------------
      #6:  48"
      #7:  49" to 54"
      #8:  55" to 60"
      #9:  61" to 67"
      #10: 68" to 73"
      #11: 74" to 79"
      #12: 80"
      ```
      let minor = Math.min(length, width),
          major = Math.max(length, width);

      let minorCells = this.getMinorCells(minor)
      let majorCells = this.getMajorCells(major)

      return minorCells * majorCells * panels
    },
    getWallPower(cellQty, cellPower=5.4, rounding) {
      if (rounding) {
        return this.$options.filters.round(cellQty * cellPower / 5, 0) * 5
      } else {
        return cellQty * cellPower
      }
    },
    isSolarable(brand, length_in, width_in) {
      /**************************************
      New formula: IF(AND(
          MIN(E80,F80)>=24, MIN(E80,F80)<=44, MAX(E80,F80)>=48, MAX(E80,F80)<=80
        ), "Active","Non-Active")
      ***************************/
      if (brand == 'Mitrex') {
        let minor = Math.min(length_in, width_in),
            major = Math.max(length_in, width_in);

        if (
          // Math.min(length_in, width_in) >= 25 &&
          // Math.min(length_in, width_in) <= 44 &&
          // Math.max(length_in, width_in) >= 48 &&
          // Math.max(length_in, width_in) <= 80
          24 <= minor <= 43 && 48 <= major <= 80 
        ) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    calculateCellQty(length_in, width_in, piece_qty) {

      const { estimation } = this;

      var width_mm = width_in * 25.4,
          length_mm = length_in * 25.4,
          min_width = Math.min(width_mm, 1100),
          min_length = Math.min(length_mm, 2050);

      let calc_1 = (
        min_width - 2 * +estimation.side_margin - Math.floor(
          min_width / +estimation.cell_length
        ) * +estimation.string_distance
      ) / +estimation.cell_length

      let calc_2 = 0

      if (
        parseInt(
          (parseInt(calc_1) + 1) / 2
        ) - parseInt(
          parseInt(calc_1/2)
        ) > 0) {
        calc_2 = 2 * +estimation.top_margin + 2 * (
          +estimation.top_busbar_space + 
          +estimation.busbar_thickness
        )
      } else {
        calc_2 = +estimation.top_margin + 
          +estimation.bottom_margin + 
          +estimation.top_busbar_space + 
          +estimation.bottom_busbar_space + (
            2 * +estimation.busbar_thickness
          )
      }

      return parseInt(calc_1) * parseInt(
          (
              min_length - +estimation.top_margin - 
              calc_2 - Math.floor(
                min_length / +estimation.cell_width
              ) * +estimation.cell_distance
          ) / +estimation.cell_width
      ) * piece_qty
    },
    calculateSolarPanels(length_in, width_in, piece_qty) {
      return width_in >= 43.2 ? Math.floor(length_in/55.2) * piece_qty : 0
    },
    wallChanged(instance, cell, x, y, v) {
      let row = this.wallSpreadsheet.getRowData(y);

      const { wallFields, materials } = this;

      const widthInd = wallFields.indexOf('width_in'),
          lengthInd = wallFields.indexOf('length_in'),
          qtyInd = wallFields.indexOf('piece_qty'),
          sqftInd = wallFields.indexOf('area_sqft'),
          cellInd = wallFields.indexOf('cell_q'),
          brandInd = wallFields.indexOf('product_brand'),
          idInd = wallFields.indexOf('id'),
          materialInd = wallFields.indexOf('material_id'),
          powerInd = wallFields.indexOf('power'),
          recalc = [materialInd, widthInd, lengthInd, qtyInd, brandInd].includes(+x);

      const isSolarable = this.isSolarable(
        row[brandInd], 
        row[lengthInd], 
        row[widthInd]
      )

      // SQFT Calculation
      if (recalc) {
        // let formula = `=ROUND(${
        //   alph[lengthInd]
        // }${+y+1}*${
        //   alph[widthInd]
        // }${+y+1}*${
        //   alph[qtyInd]
        // }${+y+1}/144,0)`;
        let sqft = +row[lengthInd] * +row[widthInd] * +row[qtyInd] / 144

        this.wallSpreadsheet.setValueFromCoords(
          sqftInd,y,this.$options.filters.round(sqft, 2),true
        )
      }

      // Cell Quantity & Power Calculation
      if (recalc) {
        if (isSolarable) {
          let cellQty = this.getCellQty(
            row[lengthInd],
            row[widthInd],
            row[qtyInd]
          );
          this.wallSpreadsheet.setValueFromCoords(
            cellInd,y,this.$options.filters.round(cellQty,2),true
          );
          
          let material = materials.filter(d => d.id == row[materialInd])[0];
          let power = this.getWallPower(cellQty, material.cell_power, true) || 0;

          this.wallSpreadsheet.setValueFromCoords(
            powerInd,y,this.$options.filters.round(power,2),true
          );
        } else {
          this.wallSpreadsheet.setValueFromCoords(
            cellInd,y,0,true
          );

          this.wallSpreadsheet.setValueFromCoords(
            powerInd,y,0,true
          );
        }
      }

      /////////////////////////////
      //  Record modification
      ////////////////////////////
      if (idInd != -1) {
        let ind = this.modifiedDetails.indexOf(row[idInd]);
        if (ind == -1) {
          this.modifiedDetails.push(row[idInd]);
        }
      }
    },
    railChanged(instance, cell, x, y, value) {
      let row = this.railSpreadsheet.getRowData(y);

      const { railFields, materials } = this;

      const widthInd = railFields.indexOf('width_in'),
          lengthInd = railFields.indexOf('length_in'),
          qtyInd = railFields.indexOf('piece_qty'),
          sqftInd = railFields.indexOf('area_sqft'),
          lfInd = railFields.indexOf('linear_in_str'),
          panelInd = railFields.indexOf('solar_panels'),
          idInd = railFields.indexOf('id'),
          materialInd = railFields.indexOf('material_id'),
          powerInd = railFields.indexOf('power'),
          recalc = [widthInd, lengthInd, qtyInd, materialInd].includes(+x);

      // Railing Width
      // if (x == lengthInd) {
      //   this.railSpreadsheet.setValueFromCoords(
      //     widthInd,y,47.2,true
      //   );
      //   // if (value == '1100-1400') {
      //   //   this.railSpreadsheet.setValueFromCoords(
      //   //     widthInd,y,43.2,true
      //   //   );
      //   // }
      // }
      
      // SQFT Calculation
      if (recalc) {
        // let formula = `=ROUND(${
        //   alph[lengthInd]
        // }${+y+1}*${
        //   alph[widthInd]
        // }${+y+1}*${
        //   alph[qtyInd]
        // }${+y+1}/144,0)`;
        let sqft = +row[lengthInd] * +row[widthInd] * +row[qtyInd] / 144

        this.railSpreadsheet.setValueFromCoords(
          sqftInd,y,this.$options.filters.round(sqft, 2),true
        );
      }

      // Linear Feet Calculation
      if (recalc) {
        // let formula = `=ROUND(${
        //   alph[lengthInd]
        // }${+y+1}*${
        //   alph[qtyInd]
        // }${+y+1},0)`;
        
        let lft = +row[lengthInd] * +row[qtyInd]

        this.railSpreadsheet.setValueFromCoords(
          lfInd,y,this.$options.filters.round(lft, 2),true
        );
      }

      // Solar Panels and Power Calculation
      if (recalc) {
        let panels = this.calculateSolarPanels(
          row[lengthInd],
          row[widthInd],
          row[qtyInd]
        );
        this.railSpreadsheet.setValueFromCoords(
          panelInd,y,panels,true
        );

        if (row[materialInd]) {
          let SOLAR_SQFT_CONST = 16.56;
          let material = materials.filter(d => d.id == row[materialInd])[0];
          let power = panels * SOLAR_SQFT_CONST * material.capacity_w;

          this.railSpreadsheet.setValueFromCoords(
            powerInd,y,this.$options.filters.round(power,2),true
          );
        }
      }

      /////////////////////////////
      //  Record modification
      ////////////////////////////
      if (idInd != -1) {
        let ind = this.modifiedDetails.indexOf(row[idInd]);
        if (ind == -1) {
          this.modifiedDetails.push(row[idInd]);
        }
      }
    },
    railInsertRow(instance, rowNumber) {
      const widthInd = this.railFields.indexOf('width_in');

      // Automatically set width
      this.railSpreadsheet.setValueFromCoords(
        widthInd,rowNumber+1,43.2,true
      )
    },
    wallMaterialFilter(instance, cell, x, y) {
      let row = this.wallSpreadsheet.getRowData(y);
      const brandInd = this.wallFields.indexOf('product_brand');

      if (row[brandInd]) {
        return this.materials.filter(
          d => d.product_brand == row[brandInd]
        )
      } else {
        return this.materials
      }
    }
  }
}

export const commonEstimationHelpers = {
  computed: {
    lastManualSave({ estimation }) {
      let estimationElevations = estimation.items.map(d => d.elevations).flat(1);

      if (estimationElevations.length == 0) {
        return null
      } else {
        return new Date(Math.max(
          ...estimationElevations.map(d => this.parseDate(d.updated_on))
        ))
      }
    }
  },
  methods: {
    compareArr(newData, oldData) {
      let newIds = newData.map(d => parseInt(d[0])).filter(d => !!d);
      let res = oldData.map(oldDetail => {
        if (!newIds.includes(oldDetail[0])) {
          // Deleted
          return -oldDetail[0]
        } else {
          // Modified values
          let newDetail = newData.filter(d => d[0] == oldDetail[0])[0];
          let equal = newDetail.every((v, i) => {
            if (!isNaN(v) && parseFloat(v)) {
              return parseFloat(v) == parseFloat(oldDetail[i])
            } else {
              return v == newDetail[i]
            }
          });

          if (!equal) {
            return parseInt(newDetail[0])
          }
        }
      }).filter(d => !!d);

      let newIndexes = newData.map((d,i) => !d[0] ? `index-${i}` : null).filter(d => !!d);

      return res.concat(newIndexes);
    }
  }
}

export const newEstimationHelpers = {
  data() {
    return {
      modifiedDetails: []
    }
  },
  computed: {
    wallTotCols() {
      return this.wallFields.length
    },
    railTotCols() {
      return this.railFields.length
    },
    wallInd({ wallFields }) {
      return {
        widthInd: wallFields.indexOf('width_in'),
        lengthInd: wallFields.indexOf('length_in'),
        qtyInd: wallFields.indexOf('panels'),
        sqftInd: wallFields.indexOf('area'),
        cellInd: wallFields.indexOf('cell_q'),
        idInd: wallFields.indexOf('id'),
        itemInd: wallFields.indexOf('estimation_item_id'),
        powerInd: wallFields.indexOf('power'),
        elevationInd: wallFields.indexOf('elevation_id')
      }
    },
    railInd({ railFields }) {
      return {
        widthInd: railFields.indexOf('width_in'),
        lengthInd: railFields.indexOf('length_in'),
        qtyInd: railFields.indexOf('panels'),
        sqftInd: railFields.indexOf('area'),
        lfInd: railFields.indexOf('linear_in'),
        panelInd: railFields.indexOf('solar_panels'),
        idInd: railFields.indexOf('id'),
        itemInd: railFields.indexOf('estimation_item_id'),
        powerInd: railFields.indexOf('power'),
        elevationInd: railFields.indexOf('elevation_id')
      }
    }
  },
  methods: {
    setWidth() {
      let el = document.querySelector('#estimation');
      this.detailWidth = el.clientWidth - parseFloat(helpers.getStyle(
        el, 'padding-left'
      ).replace("px", "")) - parseFloat(helpers.getStyle(
        el, 'padding-right'
      ).replace("px", "")) - 43.6 - 36;
    },
    updateParam(field, value) {
      this.estimation[field] = value;
    }, 
    isSolarable(brand, length_in, width_in) {
      if (brand == 'Mitrex') {
        if (
          Math.min(length_in, width_in) >= 25 &&
          Math.min(length_in, width_in) <= 44 &&
          Math.max(length_in, width_in) >= 48 &&
          Math.max(length_in, width_in) <= 80
        ) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    calculateCellQty(length_in, width_in, piece_qty) {

      const { estimation } = this;

      var width_mm = width_in * 25.4,
          length_mm = length_in * 25.4,
          min_width = Math.min(width_mm, 1100),
          min_length = Math.min(length_mm, 2050);

      let calc_1 = (
        min_width - 2 * +estimation.side_margin - Math.floor(
          min_width / +estimation.cell_length
        ) * +estimation.string_distance
      ) / +estimation.cell_length

      let calc_2 = 0

      if (
        parseInt(
          (parseInt(calc_1) + 1) / 2
        ) - parseInt(
          parseInt(calc_1/2)
        ) > 0) {
        calc_2 = 2 * +estimation.top_margin + 2 * (
          +estimation.top_busbar_space + 
          +estimation.busbar_thickness
        )
      } else {
        calc_2 = +estimation.top_margin + 
          +estimation.bottom_margin + 
          +estimation.top_busbar_space + 
          +estimation.bottom_busbar_space + (
            2 * +estimation.busbar_thickness
          )
      }

      return parseInt(calc_1) * parseInt(
          (
              min_length - +estimation.top_margin - 
              calc_2 - Math.floor(
                min_length / +estimation.cell_width
              ) * +estimation.cell_distance
          ) / +estimation.cell_width
      ) * piece_qty
    },
    calculateSolarPanels(length_in, width_in, piece_qty) {
      return width_in >= 43.2 ? Math.floor(length_in/55.2) * piece_qty : 0
    },
    wallChanged(change) {
      const { wallInd } = this;
      const trigger = [wallInd.widthInd, wallInd.lengthInd, wallInd.qtyInd, wallInd.itemInd].includes(+change.x);
      const recalcArea = [wallInd.widthInd, wallInd.lengthInd, wallInd.qtyInd].includes(+change.x);

      let row = this.wallSpreadsheet.getRowData(change.y);
      /////////////////////////////
      //  Record modification
      ////////////////////////////
      if (wallInd.idInd != -1) {
        let ind = this.modifiedDetails.indexOf(row[wallInd.idInd]);
        if (ind == -1) {
          this.modifiedDetails.push(row[wallInd.idInd]);
        }
      }

      if (trigger) {
        if (recalcArea && change.newValue.toString().includes(',')) {
          this.wallSpreadsheet.setValueFromCoords(
            change.x,change.y,change.newValue.replaceAll(',', ''),true
          )
        } else {
          const recalcPower = trigger && !!row[wallInd.itemInd],
              length = this.wallSpreadsheet.getCellFromCoords(wallInd.lengthInd, change.y).innerHTML,
              width = this.wallSpreadsheet.getCellFromCoords(wallInd.widthInd, change.y).innerHTML,
              quant = this.wallSpreadsheet.getCellFromCoords(wallInd.qtyInd, change.y).innerHTML;

          // SQFT Calculation
          if (recalcArea) {
            let sqft = +length * +width * +quant / 144

            this.wallSpreadsheet.setValueFromCoords(
              wallInd.sqftInd,change.y,this.$options.filters.round(sqft, 2),true
            )
          }

          // Solar Power Calculation
          if (recalcPower) {
            let ind = this.estimation.items.map(d => d.id).indexOf(+row[wallInd.itemInd]);
            let facing = this.estimation.items[ind].materials.filter(
              d => d.product_master.product_category_id == 13
            )[0];

            const isSolarable = this.isSolarable(
              facing.product_master.product_brand, 
              +length, 
              +width
            )

            // Cell Quantity & Power Calculation
            if (isSolarable) {
              let cellQty = this.calculateCellQty(+length, +width, +quant);
              this.wallSpreadsheet.setValueFromCoords(
                wallInd.cellInd,change.y,this.$options.filters.round(cellQty,2),true
              );
              
              let power = cellQty * facing.product_master.cell_power || 0;

              this.wallSpreadsheet.setValueFromCoords(
                wallInd.powerInd,change.y,this.$options.filters.round(power,2),true
              );
            } else {
              this.wallSpreadsheet.setValueFromCoords(
                wallInd.cellInd,change.y,0,true
              );

              this.wallSpreadsheet.setValueFromCoords(
                wallInd.powerInd,change.y,0,true
              );
            }
          }
        }
      }
    },
    railChanged(change) {
      const { railInd } = this;
      const trigger = [railInd.widthInd, railInd.lengthInd, railInd.qtyInd, railInd.itemInd].includes(+change.x);
      const recalcArea = [railInd.widthInd, railInd.lengthInd, railInd.qtyInd].includes(+change.x);

      let row = this.railSpreadsheet.getRowData(change.y);
      /////////////////////////////
      //  Record modification
      ////////////////////////////
      if (railInd.idInd != -1) {
        let ind = this.modifiedDetails.indexOf(row[railInd.idInd]);
        if (ind == -1) {
          this.modifiedDetails.push(row[railInd.idInd]);
        }
      }

      if (trigger) {
        if (recalcArea && change.newValue.toString().includes(',')) {
          this.railSpreadsheet.setValueFromCoords(
            change.x,change.y,change.newValue.replaceAll(',', ''),true
          )
        } else {
          const recalcLinearFt = [railInd.lengthInd, railInd.qtyInd].includes(+change.x),
              recalcPower = trigger && !!row[railInd.itemInd],
              length = this.railSpreadsheet.getCellFromCoords(railInd.lengthInd, change.y).innerHTML,
              width = this.railSpreadsheet.getCellFromCoords(railInd.widthInd, change.y).innerHTML,
              quant = this.railSpreadsheet.getCellFromCoords(railInd.qtyInd, change.y).innerHTML;

          // Linear Feet Calculation
          if (recalcLinearFt) {
            let lft = +length * +quant
  
            this.railSpreadsheet.setValueFromCoords(
              railInd.lfInd,change.y,this.$options.filters.round(lft, 2),true
            );
          }
          
          // SQFT Calculation
          if (recalcArea) {
            let sqft = +length * +width * +quant / 144
  
            this.railSpreadsheet.setValueFromCoords(
              railInd.sqftInd,change.y,this.$options.filters.round(sqft, 2),true
            );
          }
  
          // Solar Panels and Power Calculation
          if (recalcPower) {
            let panels = this.calculateSolarPanels(length, width, quant);
  
            this.railSpreadsheet.setValueFromCoords(
              railInd.panelInd,change.y,panels,true
            );
  
            if (row[railInd.itemInd]) {
              let SOLAR_SQFT_CONST = 16.56;
              let ind = this.estimation.items.map(d => d.id).indexOf(+row[railInd.itemInd]);
              let material = this.estimation.items[ind].materials.filter(
                d => d.product_master.product_category_id == 20
              )[0];
              let power = panels * SOLAR_SQFT_CONST * material.product_master.capacity_w;
  
              this.railSpreadsheet.setValueFromCoords(
                railInd.powerInd,change.y,this.$options.filters.round(power,2),true
              );
            }
          }
        }
      }
    },
    railInsertRow(instance, rowNumber) {
      const widthInd = this.railFields.indexOf('width_in');

      // Automatically set width
      this.railSpreadsheet.setValueFromCoords(
        widthInd,rowNumber+1,43.2,true
      )
    }
  }
}

export const condensedEstimationHelpers = {
  computed: {
    grandTotal({ item, material }) {
      return item.elevations.reduce((a,b) => {
        let res = a;
        res += b.manual_non_active_sqft * material.manual_non_active_dollar_sqft
        res += b.manual_returns_and_flashings_sqft * material.manual_returns_dollar_sqft
        if (material.product_master.product_brand === 'Mitrex') {
          res += b.manual_active_sqft * material.manual_active_dollar_sqft
        }
        return res
      }, 0)
    }
  }
}
